import ListingCardsBody from './ListingCardsBody';

const View = (props) => <ListingCardsBody {...props} />;

export default View;
